import { sessionStorage } from '@/app/shared/services/sessionStorage.service';
import { mainEventsApi } from '@/app/shared/services/apis/mainEventsApi.service';

const StorageKeys = Object.freeze({
    mainEventId: 'routing/mainEventId',
});

const initialState = () => ({
    mainEvents: {
        data: [],
        loaded: false,
        loading: false,
    },
    selectedMainEventId: null,
});

const getters = {
    selectedEvent(state) {
        return state.mainEvents.data.find(
            (mainEvent) => mainEvent.id === state.selectedMainEventId
        );
    },
    mainEvents(state) {
        return state.mainEvents.data;
    },
    areMainEventsLoading(state) {
        return state.mainEvents.loading;
    },
    areMainEventsLoaded(state) {
        return state.mainEvents.loaded;
    },
};

const actions = {
    async loadSelectedMainEvent({ commit }) {
        const mainEventId = sessionStorage.get(StorageKeys.mainEventId);
        commit('setSelectedMainEventId', mainEventId ? parseInt(mainEventId, 10) : null);
    },
    async loadEvents({ commit }) {
        commit('setLoadingMainEvents', true);
        try {
            const response = await mainEventsApi.getList();
            commit(
                'setMainEvents',
                response.data.map((mainEvent) => ({ id: mainEvent.id, name: mainEvent.name }))
            );
        } finally {
            commit('setLoadingMainEvents', false);
        }
    },
    async setCurrentMainEventId({ commit }, mainEventId) {
        sessionStorage.set(StorageKeys.mainEventId, mainEventId);
        commit('setSelectedMainEventId', parseInt(mainEventId, 10));
    },
};

const mutations = {
    setMainEvents(state, events) {
        state.mainEvents.data = events;
        state.mainEvents.loaded = true;
    },
    setLoadingMainEvents(state, loading) {
        state.mainEvents.loading = loading;
    },
    setSelectedMainEventId(state, mainEventId) {
        state.selectedMainEventId = mainEventId;
    },
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations,
};
